<div [ngClass]="{'current-slot': isCurrentSlot && animateEqualizer, 'list-planning-no-equalizer-margin': !animateEqualizer, 'list-planning-equalizer-margin': animateEqualizer}"
     class="list-planning">
  <div *ngIf="isCurrentSlot && !fromModifierPage" class="equalizer">
    <mwo-equalizer-icon *ngIf="animateEqualizer" [isAnimated]="animateEqualizer"
                        [timeslotColor]="color"></mwo-equalizer-icon>
  </div>
    <div class="slot-color" [style.background-color]="color"></div>
    <p class="left" *ngIf="timeSlot && timeSlot.event">
      {{ (timeSlot.event.name) | titlecase }}
    </p>
    <p class="left" *ngIf="timeSlot && timeSlot.tempo">
      {{ (timeSlot.tempo.name) | titlecase }}
    </p>
    <p class="center align-right">
      {{ timeSlot | hourstamp: "startTime" : "hh:mm" }} > {{ timeSlot | hourstamp: "endTime" : "hh:mm" }}
    </p>
<!--    <p class="right">-->
<!--      <img src="/assets/icons/edit-playlist.svg" alt="edit icon">-->
<!--    </p>-->
</div>
